import { Link } from 'react-router-dom';
import { Seo } from '@/components/Seo';
import { Container } from '@/components/ui/Container';
import { SectionHeading } from '@/components/ui/SectionHeading';
import { Photo } from '@/components/ui/Photo';
import { SITE } from '@/data/site';
import { useImages } from '@/lib/images';
import { useReveal } from '@/lib/useReveal';
import { PageHeader } from '@/components/ui/PageHeader';

export function About() {
  useReveal();
  const img = useImages();
  return (
    <>
      <Seo title="About" description="Grace Haven Spa is a warm, welcoming wellness sanctuary in Gaborone, Botswana, built around unhurried, personal care." />

      <PageHeader eyebrow="Our story" title="About Grace Haven" />

      <section className="bg-cream py-24">
        <Container>
          <div className="grid items-center gap-14 lg:grid-cols-2">
            <div>
              <SectionHeading
                eyebrow="Why we exist"
                title="A haven, not a production line."
                intro={`Grace Haven began with a simple wish: a place in ${SITE.city} where you are truly looked after — welcomed, listened to, and cared for, never rushed from room to room.`}
              />
              <div className="mt-6 space-y-5 font-body leading-relaxed text-muted">
                <p>
                  Our therapists are experienced and warm, and they start by asking how you'd like to feel.
                  From the botanical oils we choose to the soft light in the rooms, every detail is here to
                  help you exhale.
                </p>
                <p>Come as you are; leave a little lighter.</p>
              </div>
            </div>
            <Photo src={img.lounge} alt="The relaxation lounge at Grace Haven" className="reveal aspect-[4/5] rounded-sm shadow-soft" />
          </div>

          <div className="mt-20 grid gap-6 sm:grid-cols-3">
            {[
              { stat: 'Unhurried', label: 'Generous time for every treatment' },
              { stat: 'Personal', label: 'Care tailored to how you want to feel' },
              { stat: 'Local', label: `Proudly based in ${SITE.city}, ${SITE.country}` },
            ].map((c) => (
              <div key={c.stat} className="reveal border border-line bg-paper p-8 text-center">
                <p className="font-display text-3xl text-espresso">{c.stat}</p>
                <div className="rule-gold mx-auto my-4" />
                <p className="font-body text-sm text-muted">{c.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <Link to="/booking" className="btn-primary">Book your visit</Link>
          </div>
        </Container>
      </section>
    </>
  );
}
